import type { AuthBrandConfig } from '@lightning/ui';

/** Shared auth pages (forgot/reset password) read Ethos tokens through CSS variables
 *  so the Direction B palette and National 2 apply without hard-coded values. */
export const howieAuthBrand: AuthBrandConfig = {
  logo: <img src="/logo_white.svg" alt="Howie" className="h-12 w-auto" />,
  gradientFrom: 'var(--how-space-deep)',
  gradientTo: 'var(--how-space-mid)',
  buttonBg: 'var(--how-accent-warm)',
  buttonTextColor: 'var(--how-space-deep)',
  titleColor: 'var(--how-paper-soft)',
  subtitleColor: 'color-mix(in srgb, var(--how-paper-soft) 72%, transparent)',
  linkColor: 'var(--how-paper-soft)',
  titleFont: 'var(--font-heading)',
  bodyFont: 'var(--font-body)',
  signUp: {
    title: 'Join Howie',
    subtitle: 'CREATE YOUR ACCOUNT',
  },
  signIn: {
    title: 'Welcome Back',
    subtitle: 'CONTINUE YOUR PRACTICE.',
  },
  forgotPassword: {
    title: 'Reset Password',
    subtitle: "We'll send you a reset link.",
    successTitle: 'Check Your Email',
  },
  layout: {
    logoBottomSpacing: 28,
    titleFontSize: 52,
    subtitleBottomSpacing: 34,
    cardWidth: 360,
    cardMinHeight: 260,
  },
};
